import { __assign, __extends, __rest } from "tslib";
import { difference, each, isNil, keys, mix, pick } from '@antv/util';
import { propagationDelegate } from '../util/event';
import { applyMatrix2BBox, getMatrixByTranslate } from '../util/matrix';
import { getBBoxWithClip, updateClip } from '../util/util';
import Component from './component';
var STATUS_UPDATE = 'update_status';
var COPY_PROPERTIES = ['visible', 'tip', 'delegateObject']; // æ´æ°å¯¹è±¡æ¶éè¦å¤å¶çå±æ§
var COPY_PROPERTIES_EXCLUDES = ['container', 'group', 'shapesMap', 'isRegister', 'isUpdating', 'destroyed']; // æ´æ°å­ç»ä»¶æ¶æé¤çå±æ§
var GroupComponent = /** @class */ (function (_super) {
    __extends(GroupComponent, _super);
    function GroupComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupComponent.prototype.getDefaultCfg = function () {
        var cfg = _super.prototype.getDefaultCfg.call(this);
        return __assign(__assign({}, cfg), { container: null, 
            /**
             * @private
             * ç¼å­å¾å½¢ç Map
             */
            shapesMap: {}, group: null, capture: true, 
            /**
             * @private ç»ä»¶æèå¾å½¢æ¯å¦åè®¸æ³¨å
             * @type {false}
             */
            isRegister: false, 
            /**
             * @private æ¯å¦æ­£å¨æ´æ°
             * @type {false}
             */
            isUpdating: false, 
            /**
             * @private
             * æ¯å¦åå§ç¶æï¼ä¸æ¦ renderï¼update åï¼è¿ä¸ªç¶æå°±åæ false, clear åæ¢å¤
             */
            isInit: true });
    };
    GroupComponent.prototype.remove = function () {
        this.clear();
        var group = this.get('group');
        group.remove();
    };
    GroupComponent.prototype.clear = function () {
        var group = this.get('group');
        group.clear();
        this.set('shapesMap', {});
        this.clearOffScreenCache();
        this.set('isInit', true);
    };
    GroupComponent.prototype.getChildComponentById = function (id) {
        var group = this.getElementById(id);
        var inst = group && group.get('component');
        return inst;
    };
    GroupComponent.prototype.getElementById = function (id) {
        return this.get('shapesMap')[id];
    };
    GroupComponent.prototype.getElementByLocalId = function (localId) {
        var id = this.getElementId(localId);
        return this.getElementById(id);
    };
    GroupComponent.prototype.getElementsByName = function (name) {
        var rst = [];
        each(this.get('shapesMap'), function (elem) {
            if (elem.get('name') === name) {
                rst.push(elem);
            }
        });
        return rst;
    };
    GroupComponent.prototype.getContainer = function () {
        return this.get('container');
    };
    GroupComponent.prototype.updateInner = function (cfg) {
        // this.updateInner();
        // this.set('isUpdating', false);
        this.offScreenRender();
        if (this.get('updateAutoRender')) {
            this.render();
        }
    };
    GroupComponent.prototype.render = function () {
        var offScreenGroup = this.get('offScreenGroup');
        if (!offScreenGroup) {
            offScreenGroup = this.offScreenRender();
        }
        var group = this.get('group');
        this.updateElements(offScreenGroup, group);
        this.deleteElements();
        this.applyOffset();
        if (!this.get('eventInitted')) {
            this.initEvent();
            this.set('eventInitted', true);
        }
        this.set('isInit', false);
    };
    GroupComponent.prototype.show = function () {
        var group = this.get('group');
        group.show();
        this.set('visible', true);
    };
    GroupComponent.prototype.hide = function () {
        var group = this.get('group');
        group.hide();
        this.set('visible', false);
    };
    GroupComponent.prototype.setCapture = function (capture) {
        var group = this.get('group');
        group.set('capture', capture);
        this.set('capture', capture);
    };
    GroupComponent.prototype.destroy = function () {
        this.removeEvent();
        this.remove();
        _super.prototype.destroy.call(this);
    };
    GroupComponent.prototype.getBBox = function () {
        return this.get('group').getCanvasBBox();
    };
    GroupComponent.prototype.getLayoutBBox = function () {
        var group = this.get('group');
        // é²æ­¢è¢« clear äºï¼offScreenBBox ä¸å­å¨
        var bbox = this.getInnerLayoutBBox();
        var matrix = group.getTotalMatrix();
        if (matrix) {
            bbox = applyMatrix2BBox(matrix, bbox);
        }
        return bbox; // é»è®¤è¿å getBBoxï¼ä¸åçç»ä»¶åé¨åç¬å®ç°
    };
    // å¤å on, off, emit éä¼ å° group
    GroupComponent.prototype.on = function (evt, callback, once) {
        var group = this.get('group');
        group.on(evt, callback, once);
        return this;
    };
    GroupComponent.prototype.off = function (evt, callback) {
        var group = this.get('group');
        group && group.off(evt, callback);
        return this;
    };
    GroupComponent.prototype.emit = function (eventName, eventObject) {
        var group = this.get('group');
        group.emit(eventName, eventObject);
    };
    GroupComponent.prototype.init = function () {
        _super.prototype.init.call(this);
        if (!this.get('group')) {
            this.initGroup();
        }
        this.offScreenRender(); // ç»å¶ç¦»å± group
    };
    // è·åç»ä»¶åé¨å¸å±å çåå´ç
    GroupComponent.prototype.getInnerLayoutBBox = function () {
        return this.get('offScreenBBox') || this.get('group').getBBox();
    };
    // æåºå§æå¯¹è±¡
    GroupComponent.prototype.delegateEmit = function (eventName, eventObject) {
        var group = this.get('group');
        eventObject.target = group;
        group.emit(eventName, eventObject);
        propagationDelegate(group, eventName, eventObject);
    };
    // åå»ºç¦»å±ç group ,ä¸æ·»å å¨ canvas ä¸­
    GroupComponent.prototype.createOffScreenGroup = function () {
        var group = this.get('group');
        var GroupClass = group.getGroupBase(); // è·ååç»çæé å½æ°
        var newGroup = new GroupClass({
            delegateObject: this.getDelegateObject(),
        });
        return newGroup;
    };
    // åºç¨ offset
    GroupComponent.prototype.applyOffset = function () {
        var offsetX = this.get('offsetX');
        var offsetY = this.get('offsetY');
        this.moveElementTo(this.get('group'), {
            x: offsetX,
            y: offsetY,
        });
    };
    GroupComponent.prototype.initGroup = function () {
        var container = this.get('container');
        this.set('group', container.addGroup({
            id: this.get('id'),
            name: this.get('name'),
            capture: this.get('capture'),
            visible: this.get('visible'),
            isComponent: true,
            component: this,
            delegateObject: this.getDelegateObject(),
        }));
    };
    // ç¦»å±æ¸²æ
    GroupComponent.prototype.offScreenRender = function () {
        this.clearOffScreenCache();
        var offScreenGroup = this.createOffScreenGroup();
        this.renderInner(offScreenGroup);
        this.set('offScreenGroup', offScreenGroup);
        // åå«åå´çç bbox
        this.set('offScreenBBox', getBBoxWithClip(offScreenGroup));
        return offScreenGroup;
    };
    /**
     * @protected
     * å¨ç»ä»¶ä¸æ·»å åç»ï¼ä¸»è¦è§£å³ isReigeter çé®é¢
     * @param {IGroup} parent ç¶åç´ 
     * @param {object} cfg    åç»çéç½®é¡¹
     */
    GroupComponent.prototype.addGroup = function (parent, cfg) {
        this.appendDelegateObject(parent, cfg);
        var group = parent.addGroup(cfg);
        if (this.get('isRegister')) {
            this.registerElement(group);
        }
        return group;
    };
    /**
     * @protected
     * å¨ç»ä»¶ä¸æ·»å å¾å½¢ï¼ä¸»è¦è§£å³ isReigeter çé®é¢
     * @param {IGroup} parent ç¶åç´ 
     * @param {object} cfg    åç»çéç½®é¡¹
     */
    GroupComponent.prototype.addShape = function (parent, cfg) {
        this.appendDelegateObject(parent, cfg);
        var shape = parent.addShape(cfg);
        if (this.get('isRegister')) {
            this.registerElement(shape);
        }
        return shape;
    };
    /**
     * å¨ç»ä»¶ä¸æ·»å å­ç»ä»¶
     *
     * @param parent ç¶åç´ 
     * @param cfg å­ç»ä»¶éç½®é¡¹
     */
    GroupComponent.prototype.addComponent = function (parent, cfg) {
        var id = cfg.id, Ctor = cfg.component, restCfg = __rest(cfg, ["id", "component"]);
        // @ts-ignore
        var inst = new Ctor(__assign(__assign({}, restCfg), { id: id, container: parent, updateAutoRender: this.get('updateAutoRender') }));
        inst.init();
        inst.render();
        if (this.get('isRegister')) {
            this.registerElement(inst.get('group'));
        }
        return inst;
    };
    GroupComponent.prototype.initEvent = function () { };
    GroupComponent.prototype.removeEvent = function () {
        var group = this.get('group');
        group.off();
    };
    GroupComponent.prototype.getElementId = function (localId) {
        var id = this.get('id'); // ç»ä»¶ç Id
        var name = this.get('name'); // ç»ä»¶çåç§°
        return id + "-" + name + "-" + localId;
    };
    GroupComponent.prototype.registerElement = function (element) {
        var id = element.get('id');
        this.get('shapesMap')[id] = element;
    };
    GroupComponent.prototype.unregisterElement = function (element) {
        var id = element.get('id');
        delete this.get('shapesMap')[id];
    };
    // ç§»å¨åç´ 
    GroupComponent.prototype.moveElementTo = function (element, point) {
        var matrix = getMatrixByTranslate(point);
        element.attr('matrix', matrix);
    };
    /**
     * å¾å½¢åç´ æ°åºç°æ¶çå¨ç»ï¼é»è®¤å¾å½¢ä»éæåº¦ 0 å°å½åéæåº¦
     * @protected
     * @param {string} elmentName å¾å½¢åç´ åç§°
     * @param {IElement} newElement  æ°çå¾å½¢åç´ 
     * @param {object} animateCfg å¨ç»çéç½®é¡¹
     */
    GroupComponent.prototype.addAnimation = function (elmentName, newElement, animateCfg) {
        // ç¼å­éæåº¦
        var originOpacity = newElement.attr('opacity');
        if (isNil(originOpacity)) {
            originOpacity = 1;
        }
        newElement.attr('opacity', 0);
        newElement.animate({ opacity: originOpacity }, animateCfg);
    };
    /**
     * å¾å½¢åç´ æ°åºç°æ¶çå¨ç»ï¼é»è®¤å¾å½¢ä»éæåº¦ 0 å°å½åéæåº¦
     * @protected
     * @param {string} elmentName å¾å½¢åç´ åç§°
     * @param {IElement} originElement è¦å é¤çå¾å½¢åç´ 
     * @param {object} animateCfg å¨ç»çéç½®é¡¹
     */
    GroupComponent.prototype.removeAnimation = function (elementName, originElement, animateCfg) {
        originElement.animate({ opacity: 0 }, animateCfg);
    };
    /**
     * å¾å½¢åç´ çæ´æ°å¨ç»
     * @param {string} elmentName å¾å½¢åç´ åç§°
     * @param {IElement} originElement ç°æçå¾å½¢åç´ 
     * @param {object} newAttrs  æ°çå¾å½¢åç´ 
     * @param {object} animateCfg å¨ç»çéç½®é¡¹
     */
    GroupComponent.prototype.updateAnimation = function (elementName, originElement, newAttrs, animateCfg) {
        originElement.animate(newAttrs, animateCfg);
    };
    // æ´æ°ç»ä»¶çå¾å½¢
    GroupComponent.prototype.updateElements = function (newGroup, originGroup) {
        var _this = this;
        var animate = this.get('animate');
        var animateOption = this.get('animateOption');
        var children = newGroup.getChildren().slice(0); // åå»ºä¸ä¸ªæ°æ°ç»ï¼é²æ­¢æ·»å å° originGroup æ¶ï¼ children åå¨
        var preElement; // åé¢å·²ç»å¹éå°çå¾å½¢åç´ ï¼ç¨äº
        each(children, function (element) {
            var elementId = element.get('id');
            var originElement = _this.getElementById(elementId);
            var elementName = element.get('name');
            if (originElement) {
                if (element.get('isComponent')) {
                    // åµå¥å­ç»ä»¶æ´æ°
                    var childComponent = element.get('component');
                    var origChildComponent = originElement.get('component');
                    var newCfg = pick(childComponent.cfg, difference(keys(childComponent.cfg), COPY_PROPERTIES_EXCLUDES));
                    origChildComponent.update(newCfg);
                    originElement.set(STATUS_UPDATE, 'update');
                }
                else {
                    var replaceAttrs = _this.getReplaceAttrs(originElement, element);
                    // æ´æ°
                    if (animate && animateOption.update) {
                        // æ²¡æå¨ç»
                        _this.updateAnimation(elementName, originElement, replaceAttrs, animateOption.update);
                    }
                    else {
                        // originElement.attrs = replaceAttrs; // ç´æ¥æ¿æ¢
                        originElement.attr(replaceAttrs);
                    }
                    // å¦ææ¯åç»ï¼åç»§ç»­æ§è¡
                    if (element.isGroup()) {
                        _this.updateElements(element, originElement);
                    }
                    // å¤å¶å±æ§
                    each(COPY_PROPERTIES, function (name) {
                        originElement.set(name, element.get(name));
                    });
                    updateClip(originElement, element);
                    preElement = originElement;
                    // æ§è¡å®æ´æ°åè®¾ç½®ç¶æä½ä¸ºæ´æ°
                    originElement.set(STATUS_UPDATE, 'update');
                }
            }
            else {
                // æ²¡æå¯¹åºçå¾å½¢ï¼åæå¥å½åå¾å½¢
                originGroup.add(element); // åºè¯¥å¨ group å ä¸ª insertAt çæ¹æ³
                var siblings = originGroup.getChildren(); // åå¼èç¹
                siblings.splice(siblings.length - 1, 1); // åä»æ°ç»ä¸­ç§»é¤ï¼ç¶åæ¾å°åéçä½ç½®
                if (preElement) {
                    // åé¢å·²ç»ææ´æ°çå¾å½¢æèæå¥çå¾å½¢ï¼åå¨è¿ä¸ªå¾å½¢åé¢æå¥
                    var index = siblings.indexOf(preElement);
                    siblings.splice(index + 1, 0, element); // å¨å·²ç»æ´æ°çå¾å½¢åç´ åé¢æå¥
                }
                else {
                    siblings.unshift(element);
                }
                _this.registerElement(element); // æ³¨åèç¹
                element.set(STATUS_UPDATE, 'add'); // æ§è¡å®æ´æ°åè®¾ç½®ç¶æä½ä¸ºæ·»å 
                if (element.get('isComponent')) {
                    // ç´æ¥æ°å¢å­ç»ä»¶containerå±æ§ï¼å®ä¾ä¸å
                    var childComponent = element.get('component');
                    childComponent.set('container', originGroup);
                }
                else if (element.isGroup()) {
                    // å¦æåç´ æ¯æ°å¢å çåç´ ï¼åéåæ³¨åææçå­èç¹
                    _this.registerNewGroup(element);
                }
                preElement = element;
                if (animate) {
                    var animateCfg = _this.get('isInit') ? animateOption.appear : animateOption.enter;
                    if (animateCfg) {
                        _this.addAnimation(elementName, element, animateCfg);
                    }
                }
            }
        });
    };
    GroupComponent.prototype.clearUpdateStatus = function (group) {
        var children = group.getChildren();
        each(children, function (el) {
            el.set(STATUS_UPDATE, null); // æ¸çææ´æ°ç¶æ
        });
    };
    // æ¸çç¦»å±ç¼å­
    GroupComponent.prototype.clearOffScreenCache = function () {
        var offScreenGroup = this.get('offScreenGroup');
        if (offScreenGroup) {
            // éæ¯ååçç¦»çº¿ Group
            offScreenGroup.destroy();
        }
        this.set('offScreenGroup', null);
        this.set('offScreenBBox', null);
    };
    // private updateInner() {
    //   const group = this.get('group');
    //   const newGroup = this.createOffScreenGroup();
    //   this.renderInner(newGroup);
    //   this.applyOffset();
    //   this.updateElements(newGroup, group);
    //   this.deleteElements();
    //   newGroup.destroy(); // éæ¯èæåç»
    // }
    // è·ååçå§ææ¶çå¯¹è±¡ï¼å¨äºä»¶ä¸­æåº
    GroupComponent.prototype.getDelegateObject = function () {
        var _a;
        var name = this.get('name');
        var delegateObject = (_a = {},
            _a[name] = this,
            _a.component = this,
            _a);
        return delegateObject;
    };
    // éå å§æä¿¡æ¯ï¼ç¨äºäºä»¶
    GroupComponent.prototype.appendDelegateObject = function (parent, cfg) {
        var parentObject = parent.get('delegateObject');
        if (!cfg.delegateObject) {
            cfg.delegateObject = {};
        }
        mix(cfg.delegateObject, parentObject); // å°ç¶åç´ ä¸çå§æä¿¡æ¯å¤å¶å°èªèº«
    };
    // è·åéè¦æ¿æ¢çå±æ§ï¼å¦æååå¾å½¢åç´ å­å¨ï¼èæ°å¾å½¢ä¸å­å¨ï¼åè®¾ç½® undefined
    GroupComponent.prototype.getReplaceAttrs = function (originElement, newElement) {
        var originAttrs = originElement.attr();
        var newAttrs = newElement.attr();
        each(originAttrs, function (v, k) {
            if (newAttrs[k] === undefined) {
                newAttrs[k] = undefined;
            }
        });
        return newAttrs;
    };
    GroupComponent.prototype.registerNewGroup = function (group) {
        var _this = this;
        var children = group.getChildren();
        each(children, function (element) {
            _this.registerElement(element); // æ³¨åèç¹
            element.set(STATUS_UPDATE, 'add'); // æ§è¡å®æ´æ°åè®¾ç½®ç¶æä½ä¸ºæ·»å 
            if (element.isGroup()) {
                _this.registerNewGroup(element);
            }
        });
    };
    // ç§»é¤å¤ä½çåç´ 
    GroupComponent.prototype.deleteElements = function () {
        var _this = this;
        var shapesMap = this.get('shapesMap');
        var deleteArray = [];
        // éåè·åéè¦å é¤çå¾å½¢åç´ 
        each(shapesMap, function (element, id) {
            if (!element.get(STATUS_UPDATE) || element.destroyed) {
                deleteArray.push([id, element]);
            }
            else {
                element.set(STATUS_UPDATE, null); // æ¸çææ´æ°ç¶æ
            }
        });
        var animate = this.get('animate');
        var animateOption = this.get('animateOption');
        // å é¤å¾å½¢åç´ 
        each(deleteArray, function (item) {
            var id = item[0], element = item[1];
            if (!element.destroyed) {
                var elementName = element.get('name');
                if (animate && animateOption.leave) {
                    // éè¦å¨ç»ç»ææ¶ç§»é¤å¾å½¢
                    var callbackAnimCfg = mix({
                        callback: function () {
                            _this.removeElement(element);
                        },
                    }, animateOption.leave);
                    _this.removeAnimation(elementName, element, callbackAnimCfg);
                }
                else {
                    _this.removeElement(element);
                }
            }
            delete shapesMap[id]; // ä»ç¼å­ä¸­ç§»é¤
        });
    };
    GroupComponent.prototype.removeElement = function (element) {
        if (element.get('isGroup')) {
            var component = element.get('component');
            if (component) {
                component.destroy();
            }
        }
        element.remove();
    };
    return GroupComponent;
}(Component));
export default GroupComponent;
//# sourceMappingURL=group-component.js.map